var Haiku = require("@haiku/core");
var _code_circle_code = require("./../circle/code.js");
module.exports = {
  metadata: {
    uuid: "90324d73-5838-4221-982d-f6a287687ffa",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon5",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon5",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/c61d20c8-ce40-4e8f-bd0f-e94515091f3c/db69e5d94bb80ce142942055905bfcbf5c16445a/",
    core: "4.5.1",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: { play: { type: "string", value: "stop", edited: true } },
  eventHandlers: {
    "haiku:Main-03757d2ca1026e0a": {
      hover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "loop" });
        }
      },
      unhover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "stop" });
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 93.382,
        "sizeAbsolute.y": 92.542,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Book-e4468eb877fe838f": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 39,
        "style.margin": "0",
        "sizeAbsolute.y": 28,
        "sizeMode.y": 1,
        "translation.x": 46.69100000000001,
        "translation.y": 46.271,
        "style.zIndex": 1
      },
      "haiku:Linear-Gradient-1-452788-046565c4fc53dc07": {
        x1: "18.0667488%",
        y1: "30.1188322%",
        x2: "81.6432506%",
        y2: "68.9374649%"
      },
      "haiku:Stop-7d6c32c0d00a0b6a": { stopColor: "#A3CE32", offset: "0%" },
      "haiku:Stop-0db6ac6f6bf5ff01": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:Page-1-9e194a9728590d55": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Docs-Icon-3e7fa54381781fa0": {
        fill: "url(#linearGradient-1-452788)",
        fillRule: "nonzero",
        "translation.x": -15,
        "translation.y": -17
      },
      "haiku:Book-ca4193291b6fb497": {
        "translation.x": 14.8,
        "translation.y": 16.799999
      },
      "haiku:Shape-a1ddc5010bdaf706": {
        d:
          "M38.2085,3.541875 C36.6905,2.021875 33.2365,0.249875 28.5005,0.249875 C24.3965,0.249875 21.2545,1.583875 19.5005,2.927875 C17.7465,1.583875 14.6045,0.249875 10.5005,0.249875 C5.7665,0.249875 2.3125,2.023875 0.7925,3.541875 C0.6045,3.729875 0.5005,3.983875 0.5005,4.249875 L0.5005,26.249875 C0.5005,26.653875 0.7445,27.019875 1.1185,27.173875 C1.4925,27.327875 1.9225,27.243875 2.2085,26.957875 C3.2145,25.951875 6.0925,24.249875 10.5005,24.249875 C14.9085,24.249875 17.7885,25.951875 18.7925,26.957875 C19.1825,27.347875 19.8165,27.347875 20.2065,26.957875 C21.2125,25.951875 24.0905,24.249875 28.4985,24.249875 C32.9065,24.249875 35.7865,25.951875 36.7905,26.957875 C36.9825,27.149875 37.2365,27.249875 37.4985,27.249875 C37.6265,27.249875 37.7565,27.225875 37.8805,27.173875 C38.2545,27.019875 38.4985,26.653875 38.4985,26.249875 L38.4985,4.249875 C38.4985,3.983875 38.3925,3.729875 38.2065,3.541875 L38.2085,3.541875 Z M2.5005,24.257875 L2.5005,4.691875 C3.7085,3.679875 6.4625,2.251875 10.5005,2.251875 C14.5385,2.251875 17.2945,3.679875 18.5005,4.693875 L18.5005,24.259875 C16.6645,23.175875 13.9165,22.251875 10.5005,22.251875 C7.0845,22.251875 4.3365,23.173875 2.5005,24.259875 L2.5005,24.257875 Z M36.5005,24.257875 C34.6645,23.173875 31.9145,22.249875 28.5005,22.249875 C25.0865,22.249875 22.3365,23.173875 20.5005,24.257875 L20.5005,4.691875 C21.7065,3.679875 24.4605,2.249875 28.5005,2.249875 C32.5405,2.249875 35.2925,3.677875 36.5005,4.689875 L36.5005,24.255875 L36.5005,24.257875 Z"
      },
      "haiku:Circle-fac908014a314ee9": {
        "translation.x": 44.01025,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 46.293499999999995,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 2,
        playback: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        },
        PlayIt: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        }
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: _code_circle_code,
        attributes: {
          "haiku-id": "Circle-fac908014a314ee9",
          "haiku-var": "_code_circle_code",
          "haiku-title": "Circle",
          "haiku-source": "./code/circle/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Book-e4468eb877fe838f",
          "haiku-title": "book",
          "haiku-source":
            "designs/AnimatorWebsiteIcon5.sketch.contents/slices/book.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-e3142f9363d0a204" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-452788-046565c4fc53dc07",
                  id: "linearGradient-1-452788"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-7d6c32c0d00a0b6a" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-0db6ac6f6bf5ff01" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-9e194a9728590d55", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Docs-Icon-3e7fa54381781fa0",
                  id: "Docs-icon"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Book-ca4193291b6fb497",
                      id: "book"
                    },
                    children: [
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Shape-a1ddc5010bdaf706",
                          id: "Shape"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon5/code/main/code.js
// module id = 451
// module chunks = 127651196306611